import { useState, useCallback } from "react";

export type OpenInteractionsModalOptions = {
  initialRpcName?: string;
  rowStatus?: string;
};

export const useInteractionsModal = () => {
  const [open, setOpen] = useState(false);
  const [interaction, setInteraction] = useState<any>(null);
  const [selectedBotData, setSelectedBotData] = useState<any>(null);
  const [connectionId, setConnectionId] = useState<string | null>(null);
  const [initialRpcName, setInitialRpcName] = useState<string | null>(null);
  const [selectedRowStatus, setSelectedRowStatus] = useState<string | null>(null);

  const openModal = useCallback(
    (
      interactionData: any,
      botData: any,
      connectionId: string,
      options?: OpenInteractionsModalOptions
    ) => {
      // Interactions flow: we pass full interactions; VerticalTabs + default_rpcs
      // decide which RPCs become tabs, and use_endpoint still sees all custom_rpcs.
      setInteraction(interactionData);
      setSelectedBotData(botData);
      setConnectionId(connectionId);
      setInitialRpcName(options?.initialRpcName ?? null);
      setSelectedRowStatus(options?.rowStatus ?? null);
      setOpen(true);
    },
    []
  );

  const closeModal = useCallback(() => {
    setOpen(false);
    setInteraction(null);
    setSelectedBotData(null);
    setConnectionId(null);
    setInitialRpcName(null);
    setSelectedRowStatus(null);
  }, []);

  return {
    open,
    interaction,
    selectedBotData,
    connectionId,
    initialRpcName,
    selectedRowStatus,
    openModal,
    closeModal,
  };
};